import React from "react";
import "./index.css";

const Cookies = ({ setReadCookies }) => {
  return (
    <div className="columns cookies has-background-dark has-text-light">
      <div className="column is-8 has-text-left">
        Страницата на „СЛС Имоти” АДСИЦ използва бисквитки и подобни технологии. Научи повече{" "}
        <a href="https://bg.wikipedia.org/wiki/HTTP-%D0%B1%D0%B8%D1%81%D0%BA%D0%B2%D0%B8%D1%82%D0%BA%D0%B0">
          тук
        </a>
      </div>
      <div className="column is-4 has-text-right">
        <span onClick={setReadCookies}>съгласен съм</span>
      </div>
    </div>
  );
};

export default Cookies;



// WEBPACK FOOTER //
// ./src/presentational/Cookies/index.js